// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove fixed height: 100vh so the page can grow with content. */
.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* height: 100vh; */  /* Remove this */
  min-height: 100vh;
  padding: 20px;
  overflow-x: hidden;
  max-width: 1200px;
  margin: 0 auto;
}

/* Keep your existing styles for headings, etc. */
.centered-text {
  color: black;
  text-align: center;
}

.centered-text .MuiDataGrid-cell,
.data-grid .MuiDataGrid-columnHeaderTitle {
  color: black;
  text-align: center;
}

.grid-container {
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;
}

.zoom-controls {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.zoom-controls button {
  margin: 0 0.5rem;
}

/* Nodes by Country side-panel */
.nodes-by-country {
  color: black;
  margin-top: 2rem;
  max-height: 400px;
  overflow-y: auto;
}

.nodes-by-country ul {
  list-style: none;
  padding: 0;
}

.nodes-by-country li {
  margin-bottom: 5px;
}

/* A container for the map that can scale responsively. */
.map-container {
  width: 100%;
  margin: 20px auto;
  position: relative;
  overflow: hidden;
  text-align: center;
  /* we can show a shadow or border if desired */
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
}

/* Make sure the SVG doesn’t overflow horizontally on small screens. */
.map-container svg {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

/* Adjust map container for smaller screens if desired */
@media (max-width: 768px) {
  .page-container {
    padding: 10px;
  }
  .map-container {
    margin: 10px auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NodesPage.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB,GAAG,gBAAgB;EACtC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA,sEAAsE;AACtE;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Remove fixed height: 100vh so the page can grow with content. */\n.page-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* height: 100vh; */  /* Remove this */\n  min-height: 100vh;\n  padding: 20px;\n  overflow-x: hidden;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Keep your existing styles for headings, etc. */\n.centered-text {\n  color: black;\n  text-align: center;\n}\n\n.centered-text .MuiDataGrid-cell,\n.data-grid .MuiDataGrid-columnHeaderTitle {\n  color: black;\n  text-align: center;\n}\n\n.grid-container {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 1rem;\n}\n\n.zoom-controls {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.zoom-controls button {\n  margin: 0 0.5rem;\n}\n\n/* Nodes by Country side-panel */\n.nodes-by-country {\n  color: black;\n  margin-top: 2rem;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.nodes-by-country ul {\n  list-style: none;\n  padding: 0;\n}\n\n.nodes-by-country li {\n  margin-bottom: 5px;\n}\n\n/* A container for the map that can scale responsively. */\n.map-container {\n  width: 100%;\n  margin: 20px auto;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  /* we can show a shadow or border if desired */\n  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */\n}\n\n/* Make sure the SVG doesn’t overflow horizontally on small screens. */\n.map-container svg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n/* Adjust map container for smaller screens if desired */\n@media (max-width: 768px) {\n  .page-container {\n    padding: 10px;\n  }\n  .map-container {\n    margin: 10px auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
